function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListStatusIcon4 = function SvgNewcsDashboardListStatusIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    "data-name": "\\u56FE\\u5C42 2"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 1c1.61 0 3.12.64 4.24 1.76l.3.31.26.28V2.21c0-.3.22-.55.5-.59h.1c.3 0 .55.21.59.49v2.85c-.02.15-.09.29-.2.4l-.02.02s-.03.02-.05.03l.06-.05c-.08.08-.19.12-.3.14h-2.8a.59.59 0 0 1-.59-.55c-.03-.31.19-.59.5-.64h1.45l-.13-.15-.44-.46a4.788 4.788 0 0 0-8.1 2.07 4.81 4.81 0 0 0 2.24 5.4c1.88 1.09 4.26.77 5.79-.76.15-.17.38-.24.59-.18.22.05.39.22.44.44s-.02.44-.18.59a5.99 5.99 0 0 1-7.24.95 6.01 6.01 0 0 1-2.8-6.75C1.91 2.82 4.29 1 7 1",
    "data-name": "\\u56FE\\u5C42 1",
    style: {
      fill: "#38c213",
      strokeWidth: 0
    }
  }));
};
export default SvgNewcsDashboardListStatusIcon4;